/* Modified for Donna Karan bug fix */
class CollapsibleRow extends HTMLElement {
  constructor () {
    super()
  }
  connectedCallback () {
    ;(this.toggle = this.querySelector('.collapsible-row--toggle')),
      (this.default_state = this.menuOpened()),
      (this.description = this.querySelector('.collapsible-row--content')),
      (this.description_wrapper = this.querySelector('.collapsible-row--content-wrapper')),
      this.toggleListener(),
      this.resizeObserver()
  }
  disconnectedCallback () {
    this.toggle.off('click keydown')
  }
  toggleListener () {
    this.toggle.on('click keydown', e => {
      ;('keydown' === e.type && 'Enter' !== e.key) ||
        this.setTransitions(!this.menuOpened())
    })
  }
  resizeObserver () {
    new ResizeObserver(() => this.setTransitions(this.default_state)).observe(
      this.toggle
    )
  }
  menuOpened () {
    return 'true' === this.toggle.getAttribute('aria-expanded')
  }
  setTransitions (e) {
    this.toggle.setAttribute('aria-expanded', e);
    if (this.description_wrapper) {
      this.description_wrapper.setAttribute('data-transition-active', e),
      (this.description_wrapper.style.height = e
        ? this.description.offsetHeight + 'px'
        : '0px')
    }
  }
}
const collapsibleRowEl = customElements.get('collapsible-row-root')
collapsibleRowEl || customElements.define('collapsible-row-root', CollapsibleRow)
